import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';
import StatusMessage from '../../util/StatusMessage'

class AdminTqReportHome extends Component {

	constructor(props){
		super(props)
		this.state = {
		}
	}

	handleRendering = (e, urlInput, type, certificationType, uploadType) => {
		if(certificationType === 4){
			this.props.history.push(`/portal/app/admin/hallticket/${urlInput}/${type}/${certificationType}/${uploadType}`)
		}
		else if(urlInput === 'view' && certificationType === 0 ){
			this.props.history.push(`/portal/app/admin/hallticket/${urlInput}/${type}/${certificationType}/${uploadType}`)
		}

		else{
			this.props.history.push(`/portal/app/admin/hallticket/${urlInput}/${type}/${uploadType}`)
		}
	}

	handleReportDetails = (e) => {
    this.props.history.push('/portal/app/admin/tq/report/upload/details')
	}

	handleNotification = (e, type) => {
		this.props.history.push(`/portal/app/admin/initiate/email/notification/${type}`)
	}

	render(){
		return(
			<div>
				<Grid>
					<GridCell span="12">
						<Card style={{padding: '25px'}}>
							<GridCell span="12">
								<Typography use="headline6">TQ Report Scores Upload</Typography>
								<br/>
								<GridCell span="6">
                  <Typography use="headline7" onClick={(e) => this.handleRendering(e,"upload","new",'', "tqReport")} style={{color: 'blue',textDecorationLine: 'underline'}}> Import New </Typography>
                </GridCell>

                <GridCell span="6">
                	<Typography use="caption">Info: Sheet 1 Column Names as follows:user_id, tq_id, subject, set_no, Subject Expertise, Understanding of Pedagogical Practices, Understanding of Communication Skills, Communication Skills - Practical, Pedagogical Understanding In Online Teaching, Total</Typography>
                </GridCell>

                <GridCell span="6">
                	<Typography use="caption">Info: Sheet 2 Column Names as follows:user_id, tq_id, subject followed by theme names.</Typography>
                </GridCell>

                <GridCell span="6">
                  <Typography use="headline7" onClick={(e) => this.handleRendering(e,"view","history", 4, 'tqReport')} style={{color: 'blue',textDecorationLine: 'underline'}}> View Upload History </Typography>
                </GridCell>
                
							</GridCell>
						</Card>
					</GridCell>
				</Grid>
				<Grid>
					<GridCell span="12">
						<Card style={{padding: '25px'}}>
							<GridCell span="12">
								<Typography use="headline6">TQ Report Score Upload Details</Typography>
							</GridCell>
							<GridCell span="6">
            		<Typography use="headline7" onClick={this.handleReportDetails} style={{color: 'blue',textDecorationLine: 'underline'}}> View TQ Report Details </Typography>
          		</GridCell>
						</Card>
					</GridCell>
					
				</Grid>

				<Grid>
					<GridCell span="12">
						<Card style={{padding: '25px'}}>
							<GridCell span="12">
								<Typography use="headline6">National Average Upload</Typography>
							</GridCell>
							<GridCell span="6">
            		<Typography use="headline7" onClick={(e) => this.handleRendering(e,"upload","new",'', "nationalAvgImport")} style={{color: 'blue',textDecorationLine: 'underline'}}> Import New </Typography>
          		</GridCell>
          		<GridCell span="6">
                	<Typography use="caption">Info: Column Names as follows:Type, Section, Test Track, Percentage.</Typography>
                	<br/>
                	<Typography use="caption">Type value is <b>TQ</b> for all the rows.</Typography>
                </GridCell>
          		<GridCell span="6">
                  <Typography use="headline7" onClick={(e) => this.handleRendering(e,"view","history", 0, 'nationalAvgImport')} style={{color: 'blue',textDecorationLine: 'underline'}}> View Upload History </Typography>
              </GridCell>
						</Card>
					</GridCell>
					
				</Grid>


				<Grid>
					<GridCell span="12">
						<Card style={{padding: '25px'}}>
							<GridCell span="12">
								<Typography use="headline6">Email Notification for Users</Typography>
							</GridCell>
							<GridCell span="6">
            		<Typography use="headline7" onClick={(e)=>this.handleNotification(e, "report")} style={{color: 'blue',textDecorationLine: 'underline'}}> Notify User </Typography>
          		</GridCell>
						</Card>
					</GridCell>
					
				</Grid>
			</div>

		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminTqReportHome);


// WEBPACK FOOTER //
// ./src/views/admin/AdminTqReportHome.jsx